/**
 * Created by kmiltiadous on 31/07/2017.
 */
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {TravelCreditAction} from '../models/travel-credit-action';

@Injectable()
export class TravelCreditActionResolver implements Resolve<TravelCreditAction> {

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<TravelCreditAction> {

    return new Observable(observer => {
      if (route.params && route.params.id) {
        observer.next(TravelCreditAction.Edit);
        observer.complete()
      } else {
        observer.next(TravelCreditAction.Add);
        observer.complete();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/resolvers/travel-credit-action.resolver.ts